import React from 'react'
import HeaderTwo from '../../../components/header/HeaderTwo';
import Footer from '../../../components/footer/Footer';
import Breadcrumb from './Breadcrumb';
import UpcomingGames from './web-games';

function WebGames() {
  return (
    <>
    <HeaderTwo/>
    <main>
    <Breadcrumb/>
    <UpcomingGames/>
    </main>
    <Footer/>
    </>
  )
}

export default WebGames